
import PropTypes from 'prop-types'
import React, { memo } from 'react'
import cn from 'comma-number'
import Collapsible from 'Components/Collapsible'
import { getYear, isValid, parseISO } from 'date-fns'
import SvgIcon from 'Components/SvgIcon'
// import css from './styles.js'
import {
  _ListingDetailKeyContainer, _FactsContainer, _FactText, _Fact, _SvgContainer, _ViewBuildingAmenities,
} from './styles'


const BuildingKeyFacts = ({
  building,
  collapsibleIdSuffix,
  amenitiesLink,
  onInfoBoxAnchorClick,
  isPrecon,
  showAmenities,
}) => {
  const {
    ceiling_heights: ceilingHeights, building_type: buildingType,
    registration_date: registrationDate, number_units: numUnits,
    average_psf: avgSqft, floors, smallest_unit: smallestUnit, largest_unit: largestUnit,
  } = building || {}
  const date = registrationDate ? parseISO(registrationDate) : '-'
  const formattedDate = isValid(date) ? getYear(date) : null
  const { title, name } = building || {}
  const singleFloor = Number(floors) === 1
  return (
    <_ListingDetailKeyContainer>
      <Collapsible
        inputId={`KeyFacts-${collapsibleIdSuffix}`}
        openCollapseTargetId={`KeyFacts-${collapsibleIdSuffix}`}
        title={'Key Facts'}
        gaActionTitle={'Listing Key Facts'}
        seoText={
          `View important details for ${title || name || ''}`
        }
        defaultShowState
        isCollapsible
        showSeparatorLine
      >
        <_FactsContainer>
          <_Fact>
            <_SvgContainer>
              <SvgIcon name={'#icon-building-keyfacts-sqft'} width={22} height={22} />
            </_SvgContainer>
            <_FactText>{ (smallestUnit && largestUnit) ? `${smallestUnit} sqft - ${largestUnit} sqft` :
              'Sqft range -'}
            </_FactText>
          </_Fact>
          <_Fact>
            <_SvgContainer>
              <SvgIcon name={'#icon-building-keyfacts-ppsf'} width={22} height={22} />
            </_SvgContainer>
            <_FactText>{avgSqft ? `Avg $${cn(avgSqft)} per square foot` : 'Avg - $ per square foot' }</_FactText>
          </_Fact>
          { !isPrecon &&
            <_Fact>
              <_SvgContainer>
                <SvgIcon name={'#icon-building-keyfacts-age'} width={22} height={22} />
              </_SvgContainer>
              <_FactText>{formattedDate ? `Built in ${formattedDate}` : 'Built in -'}</_FactText>
            </_Fact>
          }
          <_Fact>
            <_SvgContainer>
              <SvgIcon name={'#icon-building-keyfacts-details'} width={22} height={22} />
            </_SvgContainer>
            <_FactText>
              {(floors && numUnits) ?
                `${floors} ${singleFloor ? 'floor' : 'floors'}/ ${numUnits} units` : '- floor/ - unit'}
            </_FactText>
          </_Fact>
          <_Fact>
            <_SvgContainer>
              <SvgIcon name={'#icon-building-keyfacts-type'} width={22} height={22} />
            </_SvgContainer>
            <_FactText>{!buildingType ? 'Building type -' :
              buildingType === 'Townhouse' ? buildingType : `${buildingType} condo`}
            </_FactText>
          </_Fact>
          {
            isPrecon &&
            <_Fact>
              <_SvgContainer>
                <SvgIcon name={'#icon-building-keyfacts-ceiling'} width={22} height={22} />
              </_SvgContainer>
              <_FactText>{ceilingHeights ? `Ceilings - ${ceilingHeights}` : 'Ceilings up to -ft'}</_FactText>
            </_Fact>

          }
          <_Fact isAmenities showAmenities={showAmenities}>
            <_SvgContainer>
              <SvgIcon name={'#icon-building-keyfacts-amenities'} width={22} height={22} />
            </_SvgContainer>
            <_FactText showAmenities={showAmenities}>
              <a
                onClick={showAmenities ? () => onInfoBoxAnchorClick(amenitiesLink) : null}
              >
                {showAmenities ? 'View Building Amenities' : 'Building Amenities Unavailable'}
              </a>
            </_FactText>
          </_Fact>
          <_ViewBuildingAmenities
            secondary
            onClick={showAmenities ? () => onInfoBoxAnchorClick(amenitiesLink) : null}
            showAmenities={showAmenities}
          >
            {showAmenities ? 'View Building Amenities' : 'Building Amenities Unavailable'}
          </_ViewBuildingAmenities>
        </_FactsContainer>
      </Collapsible>
    </_ListingDetailKeyContainer>
  )
}


BuildingKeyFacts.propTypes = {
  building: PropTypes.shape({
    ceiling_heights: PropTypes.string,
    building_type: PropTypes.string,
    smallest_unit: PropTypes.number,
    largest_unit: PropTypes.number,
    number_units: PropTypes.number,
    average_psf: PropTypes.number,
    floors: PropTypes.number,
    registration_date: PropTypes.string,
  }),
  amenitiesLink: PropTypes.string,
  isPrecon: PropTypes.bool,
  navigationLinks: PropTypes.shape({
    listingDetails: PropTypes.string,
    amenities: PropTypes.string,
  }),
  collapsibleIdSuffix: PropTypes.string,
  onInfoBoxAnchorClick: PropTypes.func,
  showAmenities: PropTypes.bool,
}

export default memo(BuildingKeyFacts)
